module.exports = __webpack_public_path__ + "static/media/Mindaka.5deeffba.jpg";